import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=281de916"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports